import { useState, useRef } from 'react';

import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import ouch from '../../sounds/ouch.mp3'
import squish from '../../sounds/squish.wav'
import click from '../../sounds/click.mp3'
import { data } from './data/data_02_pistopaikka'

import kuva from './images/insulin_shot_areas2.png'

const Scene_02_pistopaikka_2 = ({ scoreHandler, soundsOn }) => {


    const [sallitutYritykset, setSallitutYritykset] = useState(2)
    const [pistopaikkaFail, setPistopaikkaFail] = useState(false)

    const [playOuch] = useSound(ouch);
    const [playSquish] = useSound(squish);
    const [playClick] = useSound(click);

    // kuvan leveys 450px, korkeus 596px
    // const [coords1, setCoords1] = useState([])//oik olkap.
    const [coords1, setCoords1] = useState([51, 174, 52, 182, 50, 194, 44, 200, 44, 188, 51, 174])//o olkap ed - modattu
    const [coords2, setCoords2] = useState([161, 169, 167, 180, 169, 197, 157, 188, 156, 177, 161, 169])//v olkap ed - modattu
    const [coords3, setCoords3] = useState([255, 172, 263, 177, 263, 193, 251, 200, 251, 183, 255, 172])//v olkap tak - modattu
    const [coords4, setCoords4] = useState([372, 167, 379, 184, 379, 194, 370, 192, 368, 176, 372, 167])//o olkap tak -modattu
    const [coords5, setCoords5] = useState([66, 275, 93, 266, 124, 268, 145, 280, 146, 293, 124, 306, 85, 306, 62, 298, 66, 275])//masu -modattu
    const [coords6, setCoords6] = useState([279, 308, 307, 331, 313, 343, 311, 361, 300, 370, 282, 367, 273, 358, 276, 328, 279, 308])//v pakara - modattu
    const [coords7, setCoords7] = useState([367, 306, 377, 357, 355, 364, 343, 352, 348, 332, 367, 306])//o pakara -modattu
    const [coords8, setCoords8] = useState([55, 356, 63, 370, 66, 381, 65, 404, 59, 419, 54, 382, 55, 356])//o reisi ed - modattu
    const [coords9, setCoords9] = useState([153, 354, 151, 418, 145, 405, 145, 365, 153, 354])//v reisi ed - modattu
    const [coords10, setCoord10] = useState([274, 375, 292, 397, 292, 425, 280, 433, 273, 400, 274, 375])//v reisi tak - modattu
    const [coords11, setCoords11] = useState([374, 374, 375, 427, 368, 433, 364, 423, 366, 382, 374, 374])//o reisi tak - modattu
    const [coordsWhole, setCoordsWhole] = useState([0, 0, 450, 596]) // modattu


    const imageRef = useRef(null);

    const [yritystenLkm, setYritystenLkm] = useState(0)


    const handleClickHit = (e, p) => {
        e.preventDefault();


        if (soundsOn) {
            playClick()
        }

        scoreHandler("Teijan avulla ok")


    }


    const handleClickWhole = (e) => {
        e.preventDefault();

        if (soundsOn) {
            // playWrongAnswer()
        }

        if (yritystenLkm == sallitutYritykset) {
            scoreHandler("Teijan avulla ei ok")


        }

        setYritystenLkm(yritystenLkm + 1)
    }



    return (


        <div className='sceneContainer' >

            <div id='image' className='centered'>

                <img src={kuva}
                    alt='human shape'
                    useMap='#iMap'
                    ref={imageRef}
                />
                {/* <img className='sameSizeImg' src={kuva} alt='kuva' /> */}
            </div>

            <map name='iMap'>
                <area shape="poly" coords={coords1} alt="1" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords2} alt="2" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords3} alt="3" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords4} alt="4" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords5} alt="5" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords6} alt="6" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords7} alt="7" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords8} alt="8" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords9} alt="9" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords10} alt="10" onClick={(e) => handleClickHit(e, 1)} href="" />
                <area shape="poly" coords={coords11} alt="11" onClick={(e) => handleClickHit(e, 1)} href="" />

                {/* <area shape="rect" coords={coordsWhole} alt="whole" onClick={(e) => handleClickWhole(e, 0)} /> */}
                <area shape="rect" coords={coordsWhole} alt="whole" onClick={(e) => handleClickWhole(e, 0)} href="" />



            </map>

            <div id='question'>


                {/* {!pistopaikkaFail ? <h5>{data.kysymysteksti_1}</h5> : <h5>{data.kysymysteksti_2}</h5>} */}

                <h5>{(data.kysymysteksti_2 != null && data.kysymysteksti_2 != "") ? data.kysymysteksti_2 : null}</h5>
                <p>
                    yritykset: {yritystenLkm}
                </p>

            </div>

            <div id='actions'>
                {/* <button onClick={() => jatka()}>jatka</button> */}
            </div>
        </div >

    )

}

export default Scene_02_pistopaikka_2